const keyArray = new Uint8Array([23, 91, 142, 56, 213, 77, 29, 183, 62, 98, 47, 150, 64, 11, 128, 202, 13, 33, 190, 9, 217, 155, 49, 87]);
const ivArray = new Uint8Array([45, 162, 28, 234, 97, 12, 205, 87]);

export type SUZ18Header = {
	ClientData: {
		ClientAppInfo: {
			KnownClientApp: number,
			PermissionVersion: string;
		},
		ClientVersion: string;
		ClientIdentityName: string;
		Username: string;
		Password: string;
	}
};

function concatUint8Arrays(...arrays: Uint8Array[]) {
	const totalLength = arrays.reduce((sum, arr) => sum + arr.length, 0);
	const result = new Uint8Array(totalLength);
	let offset = 0;
	for (const arr of arrays) {
		result.set(arr, offset);
		offset += arr.length;
	}

	return result;
}

export async function encryptSUZ18ClientDataHeader(data: SUZ18Header) {
	const today = new Date().toISOString().split('T')[0].replaceAll('-', '');
	const dateBytes = new TextEncoder().encode(today);

	const fullKey = concatUint8Arrays(keyArray, dateBytes);
	const fullIV = concatUint8Arrays(ivArray, dateBytes);

	const cryptoKey = await crypto.subtle.importKey(
		'raw',
		fullKey.buffer,
		{ name: 'AES-CBC' },
		false,
		['encrypt']
	);

	const dataBytes = new TextEncoder().encode(JSON.stringify(data));

	const encrypted = await crypto.subtle.encrypt(
		{ name: 'AES-CBC', iv: fullIV.buffer },
		cryptoKey,
		dataBytes
	);

	return btoa(String.fromCharCode(...new Uint8Array(encrypted)));
}
